import axios from '@/libs/api.request'
import config from '@/config'

export const getCompanyinfo = (Cid) => {
  return axios.request({
    url: '/v1/apply/company/',
    method: 'get',
    params: {
      Cid
    }
  })
}
export const getsdk = (Sdk, roomid) => {
  return axios.request({
    url: '/v1/apply/sdk/',
    method: 'get',
    params: {
      Sdk,
      roomid
    }
  })
}

export const roomok = (data) => {
  return axios.request({
    url: '/v1/apply/roomstate_ok/',
    method: 'post',
    data
  })
}
export const perinbox = (data) => {
  return axios.request({
    url: '/v1/apply/perinbox/',
    method: 'post',
    data
  })
}
export const roomchange = (data) => {
  return axios.request({
    url: '/v1/apply/roomchange/',
    method: 'post',
    data
  })
}

export const getroomrand = (State, perid, comid, Jid, Aid) => {
  return axios.request({
    url: '/v1/apply/getroomrand/',
    method: 'get',
    params: {
      State,
      perid,
      comid,
      Jid,
      Aid
    }
  })
}

export const getroomstate = (State) => {
  return axios.request({
    url: '/v1/apply/roomstate/',
    method: 'get',
    params: {
      State
    }
  })
}

export const getapplyapplication = (page, limit, key, Cid) => {
  return axios.request({
    url: '/v1/apply/applyapplication/',
    method: 'get',
    params: {
      key,
      Cid,
      page,
      limit
    }
  })
}

export const getperjob = (Cid, Jid) => {
  return axios.request({
    url: '/v1/apply/perjob/',
    method: 'get',
    params: {
      Cid,
      Jid
    }
  })
}

export const getjobstypeList = (value, level) => {
  return axios.request({
    url: '/v1/apply/jobstypelist/',
    method: 'get',
    params: {
      value,
      level
    }
  })
}

export const getjoblist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/apply/job/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const changecompanyonline = (data, meth) => {
  return axios.request({
    url: '/v1/apply/companyonline/',
    method: meth,
    data
  })
}

export const jobfairapplypost = (data, meth) => {
  return axios.request({
    url: '/v1/apply/jobfairapply/',
    method: meth,
    data
  })
}

export const changecompanystate = (data, meth) => {
  return axios.request({
    url: '/v1/apply/changecompanystate/',
    method: meth,
    data
  })
}

export const operationcompanyinfo = (data, meth) => {
  return axios.request({
    url: '/v1/apply/company/',
    method: meth,
    data
  })
}
export const operationjob = (data, meth) => {
  return axios.request({
    url: '/v1/apply/job/',
    method: meth,
    data
  })
}

export const changeJob = (data, meth) => {
  return axios.request({
    url: '/v1/apply/changeJob/',
    method: meth,
    data
  })
}

export const changePer = (data, meth) => {
  return axios.request({
    url: '/v1/apply/perchange/',
    method: meth,
    data
  })
}

export const getJobfairlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/account/jobfair/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}
